var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpDownArrows(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 12,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.253 4.821a.54.54 0 00.535-.535.533.533 0 00-.159-.377L4.88.159A.533.533 0 004.503 0a.533.533 0 00-.377.159l-3.75 3.75c-.1.1-.16.234-.16.377a.54.54 0 00.537.535h7.5zm-3.75 6.965a.533.533 0 00.376-.16l3.75-3.75c.1-.1.16-.234.16-.376a.54.54 0 00-.536-.536h-7.5a.54.54 0 00-.536.536c0 .142.058.276.159.377l3.75 3.75c.1.1.234.159.377.159z",
    fill: "currentColor"
  })));
}
export default SvgUpDownArrows;